<template>
  <div>
    <vs-popup
      v-if="boardUserData"
      class="profile-card"
      :title="boardUserData.userData.firstName + `'s Profile Card`"
      :active.sync="profileCardPopupActive"
      :button-close-hidden="true"
    >
      <profile-card-popup :boardUserData="boardUserData" />
    </vs-popup>
    <vs-prompt
      title="Remove User from Board"
      @accept="deleteBoardUser"
      accept-text="Confirm"
      :active.sync="confirmBoardUserDeletion"
    >
      <div v-if="boardUserData.userData && boardUserData.userData.firstName">
        Are you sure, you want to remove
        <b
          >{{ boardUserData.userData.firstName }}
          {{ boardUserData.userData.lastName }}</b
        >
        from this board?
      </div>
      <div v-else>
        Are you sure, you want to remove
        <b>{{ boardUserData.userData.email }}</b> from this board?
      </div>
    </vs-prompt>
    <vs-popup
      class="org-config-popup"
      :title="boardUserData.userData.firstName + `'s Update Log`"
      :active.sync="organizationConfigLogPopupActive"
    >
      <vs-table class="w-full" :data="organizationConfigurationLog">
        <template slot="thead">
          <vs-th width="150px">Last Updated On</vs-th>
          <vs-th
            v-for="(configKey, index) of organizationConfigurationKeys"
            :key="index"
          >
            {{ organizationConfiguration[configKey].title }}
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(log, indextr) in data">
            <vs-td width="150px">{{ formatDate(log.createdAt) }}</vs-td>
            <vs-td
              v-for="(configKey, indexx) of organizationConfigurationKeys"
              :key="indexx"
            >
              <span
                v-if="
                  log &&
                  log.data &&
                  log.data[configKey] &&
                  log.data[configKey].label
                "
              >
                {{ log.data[configKey].label }}
              </span>
              <span v-else-if="log && log.data && log.data[configKey]">
                {{ log.data[configKey] }}
              </span>
              <span v-else> </span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-popup>
    <div
      v-if="boardUserData"
      class="vx-card org-card user-card-grid p-2"
      :style="[
        profileCompletionMap[boardUserData._id]
          ? {
              borderBottom: '2px solid transparent',
              borderImage: `linear-gradient(to right, rgba(var(--vs-primary)) ${
                profileCompletionMap[boardUserData._id].profilePercent
              }%, transparent ${
                profileCompletionMap[boardUserData._id].profilePercent
              }%) 100% 1`,
            }
          : {},
      ]"
    >
      <!---->
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body">
          <div
            class="flex justify-between flex-wrap mb-6"
            style="align-items: flex-start"
          >
            <div>
              <div
                class="con-vs-avatar mt-0 ml-0 block 80px"
                style="
                  width: 80px;
                  height: 80px;
                  background: rgb(195, 195, 195);
                "
                @click="profileCardPopupActive = true"
              >
                <!---->
                <div
                  v-if="
                    boardUserData && boardUserData.userData.profilePictureUrl
                  "
                  class="con-img vs-avatar--con-img"
                >
                  <img
                    :src="
                      constants.s3Bucket +
                      '/editor/profile-pictures/' +
                      boardUserData.userData.profilePictureUrl
                    "
                    alt=""
                  />
                </div>
                <div v-else class="con-img vs-avatar--con-img">
                  <!-- <img src="@/assets/images/icons/gender/default.png" alt="" /> -->
                  <img
                    :src="`https://hostedboringavatars.vercel.app/api/beam?name=${avatarNameGenerator(
                      boardUserData.userData.firstName,
                      boardUserData.userData.lastName
                    )}`"
                    alt="Boring Avatar"
                  />
                </div>
              </div>
            </div>
            <!-- <div v-if="isAlexInstalled">
              <div v-if="boardUserData.level" class="level--item p-3">
                <h4>{{ boardUserData.level.label }}</h4>
              </div>
            </div> -->
            <div class="ml-3 items-center" style="justify-content: center">
              <vs-dropdown
                vs-custom-content
                vs-trigger-click
                class="cursor-pointer"
                id="dropdown-dots-btn"
              >
                <a class="a-icon cursor-pointer" href="#">
                  <!-- <vs-avatar size="38px" class="cursor-pointer" color="primary" icon-pack="feather" icon="icon-more-vertical" /> -->
                  <!-- <vs-button icon-pack="feather" icon="icon-more-vertical"></vs-button> -->
                  <feather-icon
                    svgClasses="text-grey"
                    icon="MoreVerticalIcon"
                  />
                </a>

                <vs-dropdown-menu>
                  <vs-dropdown-item
                    @click="profileCardPopupActive = true"
                    style="min-width: 11rem; font-size: 14.5px"
                  >
                    View Profile
                  </vs-dropdown-item>
                  <!-- <vs-dropdown-item
                    v-else
                    @click.stop="resendBoardInvitationLink()"
                    style="min-width: 11rem; font-size: 14.5px"
                  >
                    Resend Invite Link
                  </vs-dropdown-item> -->
                  <vs-dropdown-item
                    @click.stop="editBoardUser(boardUserData.userData.email)"
                    style="min-width: 11rem; font-size: 14.5px"
                  >
                    Edit User Details
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click.stop="showUpdateLog(boardUserData.userData._id)"
                    style="min-width: 11rem; font-size: 14.5px"
                  >
                    View Update Log
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click.stop="confirmBoardUserDeletion = true"
                    divider
                    style="min-width: 11rem; font-size: 14.5px"
                  >
                    Remove User
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
          <div class="user-name--item items-left mb-6">
            <div class="flex">
              <h4
                @click="profileCardPopupActive = true"
                class="mb-1 cursor-pointer float-left"
              >
                {{ boardUserData.userData.firstName }}
                {{ boardUserData.userData.lastName }}
              </h4>
              <vs-chip
                class="ml-2"
                color="primary"
                v-if="isSelfUser(boardUserData.userData.email)"
                >It's you</vs-chip
              >
              <!-- <feather-icon v-if="isSelfUser(boardUserData.userData.email)" icon="CheckCircleIcon" svgClasses="text-primary ml-2"/> -->
            </div>
          </div>
          <div class="user-details--item">
            <!-- Role Title -->
            <div>
              <div class="flex items-center" style="clear: both">
                <feather-icon
                  icon="BriefcaseIcon"
                  :svgClasses="'w-5 h-5 mr-3'"
                  style="color: #c5c8d2; float: left"
                />
                <p class="location">
                  <span v-if="boardUserData.roleTitle">{{
                    boardUserData.roleTitle.label || boardUserData.roleTitle
                  }}</span>
                </p>
              </div>
              <br />
            </div>
            <!-- Current Location -->
            <div>
              <div class="flex items-center" style="clear: both">
                <feather-icon
                  icon="MapPinIcon"
                  :svgClasses="'w-5 h-5 mr-3'"
                  style="color: #c5c8d2; float: left"
                />
                <p class="location">
                  <span v-if="boardUserData.currentLocation"
                    >{{ boardUserData.currentLocation.label }}
                  </span>
                </p>
              </div>
              <br />
            </div>
            <div class="flex items-center" style="clear: both">
              <feather-icon
                icon="MailIcon"
                :svgClasses="'w-5 h-5 mr-3'"
                style="color: #c5c8d2; float: left"
              />
              <p class="location">
                <span>{{ boardUserData.userData.email }}</span>
              </p>
            </div>
            <br />
          </div>
        </div>
        <div class="vx-card__footer">
          <div>
            <vs-row vs-type="flex" vs-justify="space-between">
              <!-- <vs-button v-if="!isSelfUser(boardUserData.userData.email)" class="message-btn" color="#F4F6F8" @click.stop="addChatContact()">Message</vs-button> -->
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="9"
              >
                <vs-button
                  class="message-btn w-full"
                  color="#F4F6F8"
                  @click="profileCardPopupActive = true"
                  >Profile</vs-button
                >
              </vs-col>
              <!-- v-if="boardUserData.status === 'active'" -->
              <vs-col
                vs-type="flex"
                vs-justify="right"
                vs-align="right"
                vs-w="2"
              >
                <vs-tooltip class="cursor-pointer" text="Edit User Data">
                  <vs-button
                    @click.stop="editBoardUser(boardUserData.userData.email)"
                    type="border"
                    color="primary"
                    icon="icon-edit"
                    icon-pack="feather"
                  ></vs-button>
                </vs-tooltip>
              </vs-col>
              <!-- <vs-col
                v-else
                vs-type="flex"
                vs-justify="right"
                vs-align="right"
                vs-w="2"
              >
                <vs-tooltip class="cursor-pointer" text="Resend Invite Link">
                  <vs-button
                    class="ml-2"
                    @click.stop="resendBoardInvitationLink()"
                    type="border"
                    color="primary"
                    icon="icon-send"
                    icon-pack="feather"
                  ></vs-button>
                </vs-tooltip>
              </vs-col> -->
            </vs-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileCardPopup from "../../components/ProfileCardPopup.vue";
import constants from "@/constants";
export default {
  components: {
    ProfileCardPopup,
  },
  props: {
    boardUserData: {
      type: Object,
      required: true,
    },
    isAlexInstalled: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      constants,
      profileCardPopupActive: false,
      confirmBoardUserDeletion: false,
      organizationConfigurationLog: [],
      organizationConfigLogPopupActive: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    currentBoard() {
      return this.$store.state.boards.currentBoard;
    },
    profileCompletionMap() {
      return this.$store.state.boards.profileCompletionMap;
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
    organizationConfiguration() {
      return this.$store.state.organization.organizationConfiguration;
    },
    organizationConfigurationKeys() {
      return this.organizationConfiguration
        ? Object.keys(this.organizationConfiguration)
        : [];
    },
    avatarNameGenerator() {
      return this.$store.state.users.avatarNameGenerator;
    },
  },
  watch: {
    profileCompletionMap: {
      deep: true,
      handler() {
        this.$forceUpdate();
      },
    },
  },
  methods: {
    updateActiveChatUser(contactId) {
      this.$store.commit("organizationChat/UPDATE_ACTIVE_CHAT_USER", contactId);
    },
    addChatContact() {
      const organizationId = this.boardUserData.organizationId;
      const userId = this.boardUserData.userData._id;
      this.$store
        .dispatch("organizationChat/fetchChatContactsByUserIdOrganizationId", {
          organizationId,
          userId,
        })
        .then((res) => {
          this.$store.commit(
            "organizationChat/UPDATE_ACTIVE_CHAT_USER",
            userId
          );
          if (res.total === 0) {
            const payload = {
              userId,
              organizationId: this.boardUserData.organizationId,
              status: "active",
            };
            this.$store
              .dispatch("organizationChat/createChatContact", payload)
              .then((res) => {
                this.$router.push({ name: "org-messages" });
              })
              .catch((error) => {
                throw error;
              });
          } else {
            this.$router.push({ name: "org-messages" });
          }
        });
    },
    resendBoardInvitationLink() {
      document.getElementById("dropdown-dots-btn").click();
      this.$emit(
        "resendBoardInvitationLink",
        this.boardUserData.userData.email
      );
    },
    isUserAdmin() {
      return true;
    },
    isSelfUser(email) {
      if (this.userData && this.userData.email === email) {
        return true;
      }
      return false;
    },
    editBoardUser(email) {
      this.$emit("editBoardUser", email);
    },
    deleteBoardUser() {
      this.$emit("deactivateBoardUser", this.boardUserData);
    },
    addToBoardChannel(boardUserData) {
      this.$store
        .dispatch("boards/addToBoardChannel", {
          email: boardUserData.userData.email,
          userId: boardUserData.userData._id,
          name: `${boardUserData.userData.firstName} ${boardUserData.userData.lastName}`,
          boardId: boardUserData.boardId,
          boardUserId: boardUserData._id,
          rktChannelId: this.currentBoard.rktChannelId,
        })
        .catch((err) => {
          throw err;
        });
    },
    showUpdateLog(userId) {
      if (userId && this.orgData._id) {
        this.organizationConfigLogPopupActive = true;
        this.$store
          .dispatch("boards/fetchOrganizationConfigLog", {
            userId,
            organizationId: this.orgData._id,
          })
          .then((res) => {
            console.log(res.data);
            this.organizationConfigurationLog = res.data;
          });
      }
    },
    formatDate(rawDate) {
      const date = new Date(rawDate);
      const formattedDate = date
        .toLocaleDateString("en-GB", {
          day: "numeric",
          month: "short",
          year: "numeric",
        })
        .replace(/ /g, "-");
      return formattedDate;
    },
  },
};
</script>

<style scoped>
.user-name--item h4 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  /* identical to box height */

  letter-spacing: -0.02em;
  text-transform: capitalize;

  color: #192a46;
}

.user-name--item span {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  display: flex;
  align-items: center;

  color: #636175;
}
.level--item {
  background: rgba(36, 98, 238, 0.1);
  border-radius: 4px;
}

.level--item h4 {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 17px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #2462ee;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0px 10px;
}

.user-details--item .location {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */
  display: flex;
  align-items: center;
  color: #a3a3a3;
}

.message-btn {
  background: #f4f6f8;
  border-radius: 6px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: -0.02em;

  color: #081343;
}

.profile-card .name {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 34px;
  line-height: 41px;
  letter-spacing: -0.02em;
  /* Licorice */
  color: #30384b;
}

.profile-card .role-title {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 29px;
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card .current-location,
.profile-card .email {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .heading {
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 13px;
  /* identical to box height, or 93% */
  letter-spacing: 0.03em;
  text-transform: uppercase;
  /* Echo Blue */
  color: #b2bac8;
}

.profile-card .content {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 23px;
  /* or 144% */
  /* Light Slate Grey */
  color: #798ba0;
}

.profile-card >>> .vs-popup--header {
  display: none !important;
}

.profile-card >>> .vs-popup {
  width: 950px;
}

.con-vs-popup >>> .vs-popup--content {
  padding: 0 !important;
  margin: 0 !important;
  overflow-x: hidden !important;
  width: auto !important;
  border-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}

.user-card-grid {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.org-config-popup >>> .vs-popup {
  width: 950px;
}
</style>
